import React, { useRef } from 'react';
import { Dialog, DialogContent, IconButton, DialogTitle } from '@mui/material';
import { useStylesDealingProductsListDialog } from './style';
import { TableComponents, FilterTextField, Icons } from 'components';
import DealerService from '../services';
import useCustomHook from './hooks';
import axios from 'axios';
import { useCurrencyUnit } from 'hooks';

const columns = (currencyText) => [
  {
    title: 'ردیف',
    field: 'num',
    cellStyle: {
      width: '1%',
    },
    filtering: false,
    sorting: false,
  },
  {
    title: 'شناسه محصول',
    field: 'productId',
    align: 'center',
    sorting: false,
    filterComponent: (props) => <FilterTextField size="small" isInteger {...props} />,
  },
  {
    title: 'نام محصول',
    field: 'productName',
    align: 'center',
    sorting: false,
    filtering: false,
  },
  {
    title: `قیمت محصول (${currencyText})`,
    field: 'productPrice',
    align: 'center',
    sorting: false,
    filtering: false,
  },
  {
    title: 'وضعیت',
    field: 'enable',
    align: 'center',
    sorting: false,
    filtering: false,
    render: (rd) => (rd.enable === true ? 'فعال' : 'غیرفعال'),
  },
];

const DealingProductsListDialog = ({ open, setOpen, dealingBusinessId }) => {
  const classes = useStylesDealingProductsListDialog();
  const currencyText = useCurrencyUnit(false);
  const tableRef = useRef();
  const { size, setSize, page, setPage, loading, setLoading } = useCustomHook();
  const getDealingAllowedProductsList = async (query) => {
    setLoading(true);

    let filterParams = {};
    query?.filters.forEach((f) => {
      filterParams = { ...filterParams, [f.column.field]: f.value };
    });

    try {
      const params = {
        offset: query ? query?.pageNumber * query?.pageSize : page * size,
        size: query ? query?.pageSize : size,
        dealingBusinessId,
        ...filterParams,
      };

      const res = await DealerService.getDealingAllowedProductsList(params);
      const { result } = res;
      const data = result.map((r) => ({
        productId: r.product?.entityId,
        productName: r.product?.name,
        productPrice: r.product?.price,
        enable: r.enable,
        dealingBusinessId,
      }));
      setLoading(false);
      return {
        data,
        page: query ? query?.pageNumber : page,
        totalCount: res.count || 0,
      };
    } catch (error) {
      if (axios.isCancel(error)) {
        setLoading(true);
      } else {
        setLoading(false);
        return {
          data: [],
          page: query ? query?.pageNumber : page,
          totalCount: 0,
        };
      }
    }
  };

  return (
    <>
      <Dialog
        onClose={() => setOpen(false)}
        aria-labelledby="simple-dialog-title"
        fullWidth
        maxWidth="md"
        open={open}
        className={classes.dialogMain}
      >
        <DialogTitle
          id="customized-dialog-title"
          onClose={() => setOpen(false)}
          className={classes.title}
        >
          لیست محصولات مجوز داده شده
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={() => setOpen(false)}
            size="large"
          >
            <Icons icon="Close" color="#939393" size="20" />
          </IconButton>
        </DialogTitle>
        <DialogContent className={classes.dialog}>
          {currencyText && (
            <TableComponents
              data={getDealingAllowedProductsList}
              columns={columns(currencyText)}
              ref={tableRef}
              isLoading={loading}
              onChange={(ps) => {
                setPage(ps?.pageNumber);
                setSize(ps?.pageSize);
                return getDealingAllowedProductsList(ps);
              }}
            />
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default DealingProductsListDialog;
